import Riasec from "../../icons/RIASEC";

interface RiasecFilterOptionsProps {
  filter: string;
}
const RIASECInfo: any = {
  Realistic:
    'Realistic people like working with objects, machines, tools, plants or animals, and like to be outdoors or perform athletic activities.',

  Investigative:
    'Investigative people like to observe, learn, investigate, analyze, and solve problems.',

  Artistic:
    '	Artistic people like to work in unstructured situations using their imagination and creativity.',

  Social:
    'Social people like to work with people to inspire, inform, help, train or cure them.',

  Enterprising:
    'Enterprising people like to work with people to influence, persuade and lead them, and to achieve organizational or financial goals.',

  Conventional:
    'Conventional people like to work with information, carry out detailed tasks, and have clerical or numerical interests.',
};
const RiasecFilterOptions: React.FC<RiasecFilterOptionsProps> = ({ filter }) => {
  return <div>
    <div className="flex items-center">
      <Riasec
        className={'w-5 h-5 fill-checkbox mt-0.5 mr-1 p-0.5'}
        quality={filter}
      />
      <h1 className="ml-1 font-bold text-left text-gray1 font-sm font-base">
        {filter}
      </h1>
    </div>
    <p className="text-left text-gray1 font-xs font-base">
      {RIASECInfo[filter]}
    </p>
  </div>;
};

export default RiasecFilterOptions;